module.exports = __webpack_public_path__ + "static/media/icon-logo.0b567408.svg";